module.exports = require("unist-util-source");


//////////////////
// WEBPACK FOOTER
// external "unist-util-source"
// module id = 18
// module chunks = 0 1 2 3 4 5 6 7 8 9 12 13 14